import React, { Component } from 'react';
import {connect} from 'react-redux'
import axios from 'axios';
import {removeAds} from '../../utils';


import '../../styles/classroom/ClassroomRewardRank.css'


class ClassroomRewardRank extends Component{
	state = {
		items: [],
		loading: true
	}

	componentDidMount(){
		const {lecture} = this.props
		axios.get(`/api/classroom/${lecture.id}/reward_rank`).then((response) => {
			if(response.data.code === 0){
                let data = response.data.data.reward_rank.map((item) => {
                    item.account.nickname = removeAds(item.account.nickname);
                    return item;
                });

				this.setState({items: data, loading: false})
			}
		})
	}

	renderRecord(r, i){
		return <div className="reward-list-item" key={r.account.id}>
			<div className="left-side">
				<span className="avatar">
					<img src={r.account.small_avatar_url} alt="avatar" />
				</span>
				<span className="nickname text-ellipsis">
					{i+1}. {r.account.nickname}
				</span>
				<span className="medal">
					{i === 0 &&
					<i className="iconfont icon-jinpai"></i>
					}
					{i === 1 &&
					<i className="iconfont icon-yinpai"></i>
					}
					{i === 2 &&
					<i className="iconfont icon-tongpai"></i>
					}
				</span>
			</div>
			<div className="right-side">
				{(r.sum_fee/100).toFixed(2)}元
			</div>
		</div>
	}

	render(){
		const listHeight = (window.innerHeight || screen.height) * 0.6 - 50;
		return  <div className="reward-list-container">
					<div className="reward-list" style={{height: listHeight}}>
						{this.state.loading &&
							<div className="loading"> <i className="iconfont icon-jiazai"></i> 正在加载 </div>
						}

                        {this.state.items.length === 0 &&
						<div className="text-center" style={{marginTop:"40px"}}>
							<i className="iconfont icon-hongbao" style={{color:"#888",fontSize:"40px"}}></i>
						    <p style={{color:"#888"}}>点击下方头像赞赏<br/>即刻荣登榜首</p>
						</div>
                        }

						{this.state.items.map((r, i) => {
							return this.renderRecord(r, i)
						})}
					</div>
				</div>
	}
}


ClassroomRewardRank = connect((state) => ({
	lecture: state.classroom.lecture,
}))(ClassroomRewardRank)


export default ClassroomRewardRank;




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomRewardRank.js